// https://firebase.google.com/docs/projects/learn-more?authuser=0#config-files-objects
// actual firebase config file/object is removed from source control. per Firebase documentation above:
// ```For open source projects, we generally do not recommend including your Firebase config file or config object in source control because, in most cases, your users should create their own Firebase projects and point their apps to their own backends.```
// REGAN'S NOTES ON FIREBASE:
// NOTHING IN THE CONFIG OBJECT IS SECRET. THE OBJECT PROPERTIES ARE TYPICALLY UNIQUE BUT THEY DO NOT POSE ANY TYPE OF RISK IF SOMEONE FINDS THEM IN YOUR SOURCE CODE.
// IN ORDER TO AUTHORIZE REQUESTS, I'M ALSO USING FIREBASE ON THE EXPRESS SERVER. THE CONFIGURATION IS A BIT DIFFERENT AND UNLIKE THE FRONT END CODE, YOU MUST MAINTAIN A SECRET KEY TO USE IT.

import * as firebase from "firebase/app";
import "firebase/auth";

const config = {
  apiKey: "AIzaSyAWcW4F4Aa534AI64mgHNNCEtxd3Bw8hAg",
  authDomain: "cookbook-c9144.firebaseapp.com",
  databaseURL: "https://cookbook-c9144.firebaseio.com",
  projectId: "cookbook-c9144",
  storageBucket: "cookbook-c9144.appspot.com",
  messagingSenderId: "281804153102",
  appId: "1:281804153102:web:6b28d6ccd4f8555b50f75f",
};

firebase.initializeApp(config);

export const auth = firebase.auth;

export const signOut = async () => {
  return await auth().signOut();
};

export default firebase;
